import { render, staticRenderFns } from "./VideoWidgetPanel.vue?vue&type=template&id=71b65438&scoped=true"
import script from "./VideoWidgetPanel.vue?vue&type=script&lang=js"
export * from "./VideoWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./VideoWidgetPanel.vue?vue&type=style&index=0&id=71b65438&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b65438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b65438')) {
      api.createRecord('71b65438', component.options)
    } else {
      api.reload('71b65438', component.options)
    }
    module.hot.accept("./VideoWidgetPanel.vue?vue&type=template&id=71b65438&scoped=true", function () {
      api.rerender('71b65438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/VideoWidgetPanel.vue"
export default component.exports